<template>
    <div>
        <div class="row" v-if="! showEditPage">
            <div class="col-lg-12">
                <h3 class="mb-0 text-uppercase">Employment Details</h3>
                <hr class="my-4" />
            </div>

            <div class="table-responsive" v-if="records && records.length > 0">
                <table class="table table-bordered">
                    <thead class="text-uppercase">
                        <td>
                            <h4>S/N</h4>
                        </td>
                        <td>
                            <h4>Employer Name</h4>
                        </td>
                        <td>
                            <h4>Employer Address</h4>
                        </td>
                        <td>
                            <h4>Start Date</h4>
                        </td>
                        <td>
                            <h4>End Date</h4>
                        </td>
                        <td v-if="applicant.status == 'submitted'">
                            &nbsp;
                        </td>
                    </thead>
                    <tbody
                        v-for="(record , index) in records"
                        :key="record.id"
                    >
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ index+1 }}
                            </h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ (record.employer_name) }}<br>
                                <badge
                                    type="success"
                                    v-if="record.current_status == 'yes'"
                                >
                                    Current Appointment
                                </badge>
                                <badge
                                    type="danger"
                                    v-if="record.current_status == 'no'"
                                >
                                    Past Appointment
                                </badge>
                            </h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                <span v-html="breakWord(record.employer_address, 60)"></span>
                            </h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ record.start_date | getDateFormat }}
                            </h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ (record.current_status == 'no' ? record.end_date  : null) | getDateFormat }}
                            </h4>
                        </td>
                        <td v-if="applicant.status == 'submitted'">
                            <base-button
                                type="primary" size="sm"
                                class="right"
                                @click="editEmployRecord(true, record)"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                            >
                                <i class="fa fa-pen"></i>
                                Edit
                            </base-button>
                        </td>
                    </tbody>
                </table>
            </div>

            <div class="col-lg-12 text-center" v-if="records && records.length == 0">
                <base-alert type="danger">
                    <!-- <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span> -->
                    <span class="alert-inner--text">
                        <h2 class="text-white">No Employment Records !!!</h2>
                    </span>
                </base-alert>
            </div>

            <div class="col-lg-12">
                <hr class="my-4" />
            </div>
        </div>

        <!-- edit Employment data template here -->
        <EditEmploymentDetails
            :res="record"
            :applicant="applicant"
            :editEmployRecord="editEmployRecord"
            :loadAssessmentApplicant="loadAssessmentApplicant"
            v-if="showEditPage"
        />

    </div>
</template>

<script>
    import moment from 'moment';
    import EditEmploymentDetails from './EditAssessment/EditEmploymentDetails';

    export default {
        name: 'EmploymentDetails',
        props: [ 'records', 'applicant' , 'loadAssessmentApplicant', 'privileges', 'editPage', 'breakWord' ],
        components: {
            EditEmploymentDetails
        },
        data() {
            return {
                showEditPage: false,
                record: null
            }
        },
        filters: {
            getDateFormat(value) {
                return value ? moment(value).format('MMM, YYYY') : 'N/A';
            }
        },
        methods: {
            editEmployRecord(status, data = null) {
                this.record = null;
                let text = status ? 'employ' : null;
                this.editPage(status, text);
                this.record = data;
                return this.showEditPage = ! this.showEditPage
            }
        }
    }
</script>

<style scoped>
    .no-padding-bottom {
        padding-bottom: 0rem !important
    }
    .right {
        float: right !important;
    }
    .photo-class {
        width: 200px;
        height: 200px;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>